import { ChargesContainer, OrderCharge } from "pages/OrderPages/OrderDetailPage/orderDetailPage.styles.ts";
import {
	AdjustedListTotalText,
	EstimatedTaxText,
	FreightCharge,
	OtherChargesAndDiscountsText,
	SubtotalText,
	TariffSurchargeText
} from "constants/text.ts";
import { models } from "types/api/viewModels.ts";
import { convertToTitleCase, formatPriceWithPrefix } from "utils/string.ts";
import { AcknowledgementPriceFormat, AcknowledgementPriceFormatType, OrderType } from "types/declarations/enums.ts";

interface OrderDetailsChargesProps {
	orderDetail: models["OrderDetailViewModel"];
	ackPermission: AcknowledgementPriceFormatType | undefined;
	billTo: models["BillToViewModel"] | null;
}

interface Charge {
	label: string | undefined | null;
	value: number | undefined | null;
}

const OrderDetailsCharges = ({ orderDetail, ackPermission, billTo }: OrderDetailsChargesProps) => {
	const isNetPrice = ackPermission !== AcknowledgementPriceFormat.LIST || billTo?.cashInAdvance;
	const { pricing } = orderDetail;

	const charges: Charge[] = [
		isNetPrice && pricing?.listPrice && { label: AdjustedListTotalText, value: pricing.listPrice },
		isNetPrice && pricing?.netPrice && { label: SubtotalText, value: pricing.netPrice },
		isNetPrice &&
			orderDetail.orderType === OrderType.REPLACEMENT &&
			pricing?.netPrice && {
				label: convertToTitleCase(OrderType.REPLACEMENT),
				value: -pricing.netPrice
			},
		isNetPrice &&
			pricing?.otherChargesAndDiscounts && {
				label: OtherChargesAndDiscountsText,
				value: pricing.otherChargesAndDiscounts
			},
		...((isNetPrice && pricing?.promotions) || [])
			.filter((p) => p.promotionAmount)
			.map((p) => ({ label: p.promotionName, value: p.promotionAmount })),
		isNetPrice &&
			pricing?.estimatedTax &&
			orderDetail.orderType !== OrderType.REPLACEMENT && { label: EstimatedTaxText, value: pricing.estimatedTax },
		pricing?.shippingCharges && { label: FreightCharge, value: pricing.shippingCharges },
		pricing?.tariffSurcharges && { label: TariffSurchargeText, value: pricing.tariffSurcharges }
	].filter(Boolean) as Charge[];

	return (
		<ChargesContainer>
			{charges.map((charge) => (
				<OrderCharge
					key={charge.label}
					isSubtotal={charge.label === SubtotalText}
				>
					<span>{charge.label}</span>
					<span>{formatPriceWithPrefix(charge.value)}</span>
				</OrderCharge>
			))}
		</ChargesContainer>
	);
};

export default OrderDetailsCharges;
